import { AllPreferredRoommatesState, AllPreferredRoommatesActionTypes, ALL_PREFERRED_ROOMMATES_REQUEST, ALL_PREFERRED_ROOMMATES_SUCCESS, ALL_PREFERRED_ROOMMATES_FAILURE } from "store/reducers/lodgingRequest/allPreferredRoommates/types";

const defaultState: AllPreferredRoommatesState = {
  isLoading: false,
  errorMessage: ""
};

export default function allPreferredRoommates(state = defaultState, action: AllPreferredRoommatesActionTypes): AllPreferredRoommatesState {
  switch (action.type) {
    case ALL_PREFERRED_ROOMMATES_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ALL_PREFERRED_ROOMMATES_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case ALL_PREFERRED_ROOMMATES_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};